var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.video,"player-vars":{ rel: 0 },"resize":true},on:{"playing":_vm.playing}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }